import React, { useState, useEffect } from "react";
import FyersOrderPlacement from "./FyersOrderPlacement";
import NubraOrderPlacement from "./NubraOrderPlacement";
import DhanSSOrderPlacement from "./DhanSSOrderPlacement";
import DhanAnuragOrderPlacement from "./DhanAnuragOrderPlacement";
import apiClient from "../../utils/apiClient";
import server from "../../utils/serverConfig";

export default function OrderPlacement({}) {
  const [livePositionTab, setLivePositionsTab] = useState("fyers-order");

  const [userLoading, setUserLoading] = useState(false);
  const [filteredFyersData, setFilteredFyersData] = useState([]);
  const [selectedFyersClients, setSelectedFyersClients] = useState({});

  const handleChangeTabs = (tabName) => {
    setLivePositionsTab(tabName);
  };

  const fetchFyersUserList = () => {
    setUserLoading(true);
    apiClient
      .get("get-fyers-users")
      .then((response) => {
        const activeFyersUsers = response.data.filter(
          (user) => 
            user.status === "active" && 
            (user.broker === "fyers" || 
             user.broker === "nubra" || 
             user.broker === "dhan_xts" || 
             user.broker === "dhan_xts_anurag" ||
             user.broker === "dhan_ss" ||
             user.broker === "dhan_anurag")
        );

        setFilteredFyersData(activeFyersUsers);

        // Initialize selection (all true)
        const initialFyers = Object.fromEntries(
          activeFyersUsers.map((u) => [u.client_id, true])
        );

        setSelectedFyersClients(initialFyers);
        setUserLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        setUserLoading(false);
      });
  };

  useEffect(() => {
    fetchFyersUserList();
  }, []);

  return (
    <>
      <div className="flex justify-between h-[40px] px-6 ">
        <div className=" flex h-[40px]  space-x-6">
          <div
            onClick={() => handleChangeTabs("fyers-order")}
            className={` ${
              livePositionTab === "fyers-order"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Fyers
          </div>
          <div
            onClick={() => handleChangeTabs("nubra-order")}
            className={` ${
              livePositionTab === "nubra-order"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Nubra
          </div>
          <div
            onClick={() => handleChangeTabs("dhan-ss-order")}
            className={` ${
              livePositionTab === "dhan-ss-order"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Dhan SS
          </div>
          <div
            onClick={() => handleChangeTabs("dhan-anurag-order")}
            className={` ${
              livePositionTab === "dhan-anurag-order"
                ? "text-[#07F2C7]  border-[#07F2C7]"
                : "border-transparent"
            } flex items-center border-b-[4px] text-[16px] font-semibold text-gray-400  cursor-pointer transition  duration-300 ease-in  `}
          >
            Dhan Anurag
          </div>
        </div>
      </div>

      {livePositionTab === "fyers-order" && (
        <FyersOrderPlacement
          userLoading={userLoading}
          filteredData={filteredFyersData}
          selectedClients={selectedFyersClients}
          setSelectedClients={setSelectedFyersClients}
        />
      )}
      {livePositionTab === "nubra-order" && (
        <NubraOrderPlacement
          userLoading={userLoading}
          filteredData={filteredFyersData}
          selectedClients={selectedFyersClients}
          setSelectedClients={setSelectedFyersClients}
        />
      )}
      {livePositionTab === "dhan-ss-order" && (
        <DhanSSOrderPlacement
          userLoading={userLoading}
          filteredData={filteredFyersData}
          selectedClients={selectedFyersClients}
          setSelectedClients={setSelectedFyersClients}
        />
      )}
      {livePositionTab === "dhan-anurag-order" && (
        <DhanAnuragOrderPlacement
          userLoading={userLoading}
          filteredData={filteredFyersData}
          selectedClients={selectedFyersClients}
          setSelectedClients={setSelectedFyersClients}
        />
      )}
    </>
  );
}
